module.exports = __webpack_public_path__ + "img/denied-verify.35351ff3.png";